import React from "react";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      {/* Topbar Start */}
      <div className="container-fluid py-3" style={{ backgroundColor: "#000" }}>
  <div className="container">
    <div className="row">

      <div className="col-md-6 text-start text-lg-left mb-2 mb-lg-0">
        <div className="d-inline-flex align-items-center">

          <a className="text-white pr-3" href="#">Working Hours</a>
          <span className="text-white">|</span>
          <a className="text-white px-3" href="#">Monday – Saturday: 9:00 AM – 6:00 PM</a>
          {/* <span className="text-white">|</span>
          <a className="text-white pl-3" href="#">Support</a> */}
        </div>
      </div>

      <div className="col-md-6 text-end text-lg-right">
        <div className="d-inline-flex align-items-center">
          <a className="text-white px-3" href="#">Call Us Now</a>
          <span className="text-white">|</span>
          <a className="text-white px-3" href="#">+91 78002 60986 | +91 98244 40003 </a>
          {/* <a className="text-white px-3" href="#"><i className="fab fa-linkedin-in"></i></a>
          <a className="text-white px-3" href="#"><i className="fab fa-instagram"></i></a>
          <a className="text-white pl-3" href="#"><i className="fab fa-youtube"></i></a> */}
        </div>
      </div>

    </div>
  </div>
      </div>
      {/* Topbar End */}


      {/* Navbar Start */}
      <div className="container-fluid position-relative nav-bar p-0">
        <div className="container position-relative" style={{ zIndex: 9 }}>

          <nav className="navbar navbar-expand-lg bg-secondary navbar-dark py-3 py-lg-0 pl-3 pl-lg-5">

            {/* Logo */}
            <Link to="/" className="navbar-brand d-flex align-items-center">
              <img
                src="/img/logos.png"
                alt="Logo"
                style={{
                  width: "100px",
                  height: "100px",
                  marginRight: "10px",
                  // filter: "brightness(0) invert(1)"
                }}
              />
            </Link>

            {/* Toggle */}
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Menu */}
            <div className="collapse navbar-collapse justify-content-between px-3" id="navbarCollapse">
              <div className="navbar-nav ml-auto py-0">

                <Link className="nav-item nav-link" to="/">Home</Link>
                <Link className="nav-item nav-link" to="/about">About</Link>
                <Link className="nav-item nav-link" to="/services">Services</Link>
                <Link className="nav-item nav-link" to="/projects">Projects</Link>
                <Link className="nav-item nav-link" to="/contact">Contact</Link>


              </div>
            </div>

          </nav>
        </div>
      </div>
      {/* Navbar End */}


      {/* Under Nav Start */}
      <div className="container-fluid bg-white py-3">
        <div className="container">
          <div className="row">

            {/* Office */}
            <div className="col-lg-4 text-left mb-3 mb-lg-0">
            <div className="d-inline-flex align-items-start gap-3">

              <h1
                className="flaticon-office font-weight-normal text-primary m-0"
                style={{ fontSize: "40px" }}
              ></h1>

              <div className="d-flex flex-column">
                <h5 className="mb-1">Our Office</h5>

                <p
                  className="m-0 text-nowrap"
                  style={{ fontSize: "10px", lineHeight: "1.5" }}
                >
                  UTRAULA BAZAR, BALRAMPUR-271604, UTTAR PRADESH
                </p>
              </div>

            </div>
          </div>

            {/* Email */}
            <div className="col-lg-4 text-left text-lg-center mb-3 mb-lg-0">
            <div className="d-inline-flex align-items-start gap-3">

              <h1
                className="flaticon-email font-weight-normal text-primary m-0"
                style={{ fontSize: "40px" }}
              ></h1>

              <div className="d-flex flex-column">
                <h5 className="mb-1 text-start">Email Us</h5>

                <p className="m-0" style={{ fontSize: "13px", lineHeight: "1.5" }}>
                  ecigroupindia@gmail.com
                </p>
              </div>

            </div>
          </div>

            {/* Phone */}
            <div className="col-lg-4 text-left text-lg-right mb-3 mb-lg-0">
            <div className="d-inline-flex align-items-start gap-3">

              <h1
                className="flaticon-telephone font-weight-normal text-primary m-0"
                style={{ fontSize: "40px" }}
              ></h1>

              <div className="d-flex flex-column">
                <h5 className="mb-1 text-start">Call Us</h5>

                <p
                  className="m-0"
                  style={{ fontSize: "13px", lineHeight: "1.5" }}
                >
                  7800260986, 9824440003
                </p>
              </div>

            </div>
          </div>

          </div>
        </div>
      </div>
      {/* Under Nav End */}
    </>
  );
};

export default Header;